
import config from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { Image, Card,Group,Space, Tooltip  } from '@mantine/core';
import { Trash, Resize, FileDownload } from 'tabler-icons-react';
import dayjs from 'dayjs';
import intl from "react-intl-universal";


const LastScreenTaken = (props:any) => {  
    const dispatch = useDispatch()
    const screenshots = useSelector((state: any) => state.user.identscreenshots)
    const meetinguser = useSelector((state: any) => state.user.meetinguser)
    const meetingtitle = useSelector((state: any) => state.user.meetinginfo.title)
    const token = useSelector((state: any) => state.user.token)


   // Check id User is online
 let meetinguserselectet
   meetinguserselectet = meetinguser.filter((obj: { id: any }) => {
    return obj.id === props.meetingParticipantId 
 
});

const fetchPdf = async (Id:any) => {

  let fetchurl
  try {
  if (config.downloadUrlSnapShot !== undefined) {
      fetchurl = config.downloadUrlSnapShot
   } else {
  fetchurl = "https://notarcms-hub.dev.lilenium.com/api/Snapshot/signSnapShotAndGetPdf?id="
  throw new Error ("WS: Keine Docker Umgebunsvariablen gefunden!");
  }
  } catch (e) {
  console.log("WS: Nutze Lokale Testdaten");
   } finally {}

  let now = dayjs(new Date());
  let imageid= Id
  let urltoken = "&token="+token
  let apicall = fetchurl+imageid+urltoken

  try {
    const response = await fetch(apicall);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const pdfBlob = await response.blob();
    const newFilename = meetingtitle+"_"+imageid+"_"+now.format('DD:MM:YYYY HH:mm:ss')+".pdf";
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(pdfBlob);
    link.download = newFilename;
    link.click();
  } catch (error) {
    console.error('Error fetching and opening PDF:', error);
  }
};

const paratoken = "&token="+token

  const deletscreenshot = (Id:any) => {
        const deletescreenshotpayload ={
            Id: Id,
        }  
        dispatch({ type: 'SIGNALR_DELETE_SCREENSHOT', payload: deletescreenshotpayload  });
    }

    // Filter auf particiapnt id bei mehrerer Teilnehmer im Meeting
    let screendata:any
    screendata = screenshots.filter((obj: { userParticipantId: any }) => {
          return obj.userParticipantId === props.meetingParticipantId 
       
    });

 

    
const lastElement = screendata[screendata.length - 1];
   

let lastscreen
let screenuser
    if (lastElement !== undefined){
        lastscreen = lastElement.imageSrc+paratoken;
        screenuser = lastElement.userParticipantId
    }

  return ( 
    <>
    {screenuser !== undefined &&
    <>
        <Space h="md" />
      <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Card.Section>
   
      <Image  src={lastscreen} />
      </Card.Section>
        <Group position="right" mt="md" mb="xs">
        <Tooltip label= {intl.get('LASTSCREENTAKEN_TT_OPEN')} multiline={true}>
           <span>
            <Resize size={24} strokeWidth={1} color="gray" onClick={() => props.handleOpenscreen()} />
          </span>
        </Tooltip>
        <Tooltip label={intl.get('LASTSCREENTAKEN_TT_DOWNLOAD')} multiline={true}>
           <span>
            <FileDownload size={24} strokeWidth={1} onClick={() => fetchPdf(lastElement.id)} color="green"/>
          </span>
        </Tooltip>
        <Tooltip label={intl.get('LASTSCREENTAKEN_TT_DELETE')} multiline={true}>
           <span>
            <Trash size={24} strokeWidth={1} color="red" onClick={() => deletscreenshot(lastElement.id)}/>
            </span>
        </Tooltip>
        </Group>
      </Card>
        <Space h="md" />
    </>
    }
    </>
  );
}

export default LastScreenTaken;